/** Maps a boolean pass/fail result to a display label. */
export function passedOrFailed(passed: boolean): "passed" | "failed" {
  if (passed) {
    return "passed";
  }
  return "failed";
}
